import request from '@/utils/request'
// 获取客户详情
export const getCusInfo = params =>
  request.get(`/customer-api/customer/workflow/query/${params.id}`)
// credit request 单笔query tableList
export const getTableList = params =>
  request.post('/workflow-api/credit-apply/apply/page', params)
// credit submit
export const creditSubmit = params =>
  request.post('/workflow-api/credit-apply/apply', params, {
    timeout: 300000,
  })
// get bureau table list
export const getBureauTable = id =>
  request.get(`/customer-api/bureau-report/query/dnb/lookup/workflow/${id}`)

export const vagueQuery = params =>
  request.get(`/customer-api/customer/list/${params.name}`)

// 查询active name
export const vagueActiveName = params =>
  request.get(`/masterdata-api/user/active/query/${params.name}`)

// 获取css详情
export const getCssDetail = params =>
  request.get(`/workflow-api/credit-css/approve/detail/${params.bpmId}`)

export const addCnpj = (companyId, cnpj) =>
  request.post(
    `/customer-api/bureau-report/add/report/cnpj?companyId=${companyId}&cnpj=${cnpj}`,
  )
